<!-- 생산지시서 탭 (2026-07-19) — 메인오더 상세에서 화면 이동 없이 생산지시서를
     조회·편집·출력. 문서(WorkInstruction)는 별도 모델·별도 화면(/work-instructions/:id)을
     유지하되, 일상 동선은 이 탭에서 끝나도록 기존 상세 화면을 임베드한다. -->
<template>
  <div class="wi-tab" v-loading="loading">
    <template v-if="wiId">
      <WorkInstructionDetailView :work-instruction-id="wiId" />
    </template>
    <el-empty v-else-if="!loading" description="생산지시서(공장 전달 문서)가 아직 없습니다.">
      <el-button type="primary" :loading="creating" @click="createInstruction">
        생산지시서 생성
      </el-button>
      <div class="hint">브랜드·디자인·수량은 이 메인오더에서 자동으로 승계됩니다.</div>
    </el-empty>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import axiosInstance from '@/api/axios'
import WorkInstructionDetailView from '@/views/production/WorkInstructionDetailView.vue'

const props = defineProps({
  mainRequest: { type: Object, required: true },
})

const loading = ref(false)
const creating = ref(false)
const wiId = ref(null)

const fetchInstruction = async () => {
  if (!props.mainRequest?.id) return
  loading.value = true
  try {
    const res = await axiosInstance.get('production/work-instructions/', {
      params: { main_request: props.mainRequest.id } })
    const list = res.data.results || res.data || []
    wiId.value = list.length ? list[0].id : null
  } catch (e) {
    console.error('생산지시서 조회 실패:', e)
  } finally {
    loading.value = false
  }
}

const createInstruction = async () => {
  creating.value = true
  try {
    const mr = props.mainRequest
    const res = await axiosInstance.post('production/work-instructions/', {
      main_request: mr.id, design: mr.design, brand: mr.brand,
      total_quantity: mr.production_quantity || mr.order_quantity || 0,
    })
    wiId.value = res.data.id
    ElMessage.success(`생산지시서가 생성되었습니다 (${res.data.instruction_number})`)
  } catch (e) {
    console.error('생산지시서 생성 실패:', e)
    ElMessage.error(e.response?.data?.detail || '생산지시서 생성에 실패했습니다.')
  } finally {
    creating.value = false
  }
}

watch(() => props.mainRequest?.id, fetchInstruction, { immediate: true })
</script>

<style scoped>
.wi-tab { min-height: 200px; }
.hint { margin-top: 10px; font-size: 12px; color: #909399; }
/* 임베드 시 내부 화면의 페이지 패딩 중복 제거 */
.wi-tab :deep(.work-instruction-detail) { padding: 0; }
</style>
